<template>
  <div class="logo-image-container">
    <img
      id="company-logo-image"
      :src="`/company-logo/thumbnail/${currentLogo.filename}`"
    />
    <div class="logo-image-container__button-container">
      <button class="logo-image-container__button" @click="$emit('edit')">
        <IconEdit color="blue" width="26" height="26" />
      </button>
      <button class="logo-image-container__button" @click="$emit('delete')">
        <IconDelete color="blue" width="24" height="24" />
      </button>
    </div>
  </div>
</template>

<script>
  import BaseButton from '~/components/base/BaseButton.vue';
  import IconEdit from '~/components/icon/IconEdit.vue';
  import IconDelete from '~/components/icon/IconDelete.vue';
  import { useConsultingStore } from '~/stores/consulting';

  export default {
    name: 'LogoImageContainer',
    components: { BaseButton, IconEdit, IconDelete },
    setup() {
      const consultingStore = useConsultingStore();
      return { consultingStore };
    },
    computed: {
      currentLogo() {
        return this.consultingStore.getCurrentLogo;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .logo-image-container {
    position: relative;

    &:hover {
      .logo-image-container__button-container {
        display: flex;
      }
    }

    &__button-container {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      gap: 0.25rem;
      padding: 0.5rem;
    }
    &__button {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      border: none;
      border-radius: 4px;
      background-color: rgba(219, 220, 222, 0.6);
      padding: 5px 15px;

      &:focus,
      &:active {
        box-shadow: none;
        border-radius: 10px;

        background-color: rgba(219, 220, 222, 0.8);

        &:disabled {
          border-radius: 4px;
        }
      }
    }
  }
</style>
